import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions} from '@angular/http';
// import {Http, Headers, Request, RequestOptions, RequestOptionsArgs, RequestMethod, Response} from '@angular/http';
import {LogService} from './log.service';
import {ConfigService} from './config.service';


@Injectable()
export class EmailService {
	constructor(
		private log: LogService,
		private config: ConfigService,
		private http: Http
	) {}


	// sends email using gmail OAuth servers
	sendEmail(emailFrom: string, emailTo: string, emailSubject: string, emailBody: string) {
		return new Promise( (resolve, reject) => {

			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({
				'Authorization': 'Bearer ' + accessToken,
				'Content-Type': 'application/json'
			});
			let options = new RequestOptions({ headers: headers });
			let payload = {
				emailFrom: emailFrom,
				emailTo: emailTo,
				emailSubject: emailSubject,
				emailBody: emailBody
			};
			let body = JSON.stringify(payload);

			this.http.post(this.config.basePath + '/v0/emails', body, options)
				.toPromise()
				.then( (res) => {

					// console.log(res);


					let foo = res.json();
					console.log(foo);
					// let bar: any = foo;


					resolve();
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
					reject(err);
				});
		});
	}



	// sends email using our servers
	sendEmail2(emailFrom: string, emailTo: string, emailSubject: string, emailBody: string) {
		return new Promise( (resolve, reject) => {

			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({
				'Authorization': 'Bearer ' + accessToken,
				'Content-Type': 'application/json'
			});
			let options = new RequestOptions({ headers: headers });
			let payload = {
				emailFrom: emailFrom,
				emailTo: emailTo,
				emailSubject: emailSubject,
				emailBody: emailBody
			};
			let body = JSON.stringify(payload);

			this.http.post(this.config.basePath + '/v0/emails2', body, options)
				.toPromise()
				.then( (res) => {

					// console.log(res);


					let foo = res.json();
					console.log(foo);
					// let bar: any = foo;


					resolve();
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
					reject(err);
				});
		});
	}



	// sends email using our servers
	sendEmailGroupBcc(emailFrom: string, emailTo: string, emailCc: string, emailBcc: string, emailSubject: string, emailBody: string) {
		return new Promise( (resolve, reject) => {

			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({
				'Authorization': 'Bearer ' + accessToken,
				'Content-Type': 'application/json'
			});
			let options = new RequestOptions({ headers: headers });
			let payload = {
				emailFrom: emailFrom,
				emailTo: emailTo,
				emailCc: emailCc,
				emailBcc: emailBcc,
				emailSubject: emailSubject,
				emailBody: emailBody
			};
			let body = JSON.stringify(payload);

			this.http.post(this.config.basePath + '/v0/emailsGroupBcc', body, options)
				.toPromise()
				.then( (res) => {

					// console.log(res);


					let foo = res.json();
					console.log(foo);
					// let bar: any = foo;


					resolve();
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
					reject(err);
				});
		});
	}


	sendEmailWithAttachments(emailFrom: string, emailTo: string, emailSubject: string, emailBody: string, attachments: any) {
		return new Promise( (resolve, reject) => {

			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({
				'Authorization': 'Bearer ' + accessToken,
				'Content-Type': 'application/json'
			});
			let options = new RequestOptions({ headers: headers });
			let payload = {
				emailFrom: emailFrom,
				emailTo: emailTo,
				emailSubject: emailSubject,
				emailBody: emailBody,
				attachments: attachments.join(',')
			};
			let body = JSON.stringify(payload);

			this.http.post(this.config.basePath + '/v0/emails/attachments', body, options)
				.toPromise()
				.then( (res) => {

					// console.log(res);


					let foo = res.json();
					console.log(foo);
					// let bar: any = foo;


					resolve();
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
					reject(err);
				});
		});
	}




/*
	sendAcceptLetterEmail(emailFrom: string, emailTo: string, emailSubject: string, emailBody: string, film: any) {
		return new Promise( (resolve, reject) => {

			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({
				'Authorization': 'Bearer ' + accessToken,
				'Content-Type': 'application/json'
			});
			let options = new RequestOptions({ headers: headers });
			let payload = {
				emailFrom: emailFrom,
				emailTo: emailTo,
				emailSubject: emailSubject,
				emailBody: emailBody
			};
			let body = JSON.stringify(payload);

			console.log(payload);

			resolve();


			// this.http.post(this.config.basePath + '/v0/emails', body, options)
			// 	.toPromise()
			// 	.then( (res) => {

			// 		// console.log(res);


			// 		let foo = res.json();
			// 		console.log(foo);
			// 		// let bar: any = foo;


			// 		resolve();
			// 	})
			// 	.catch((err) => {			// this is a Response object, with res.status === 401, for example
			// 		// TODO - handle errors?
			// 		this.log.error(err);
			// 		reject();
			// 	});


		});
	}




	sendRejectLetterEmail(emailFrom: string, emailTo: string, emailSubject: string, emailBody: string) {
		return new Promise( (resolve, reject) => {

			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({
				'Authorization': 'Bearer ' + accessToken,
				'Content-Type': 'application/json'
			});
			let options = new RequestOptions({ headers: headers });
			let payload = {
				emailFrom: emailFrom,
				emailTo: emailTo,
				emailSubject: emailSubject,
				emailBody: emailBody
			};
			let body = JSON.stringify(payload);

			console.log(payload);

			resolve();


			// this.http.post(this.config.basePath + '/v0/emails', body, options)
			// 	.toPromise()
			// 	.then( (res) => {

			// 		// console.log(res);


			// 		let foo = res.json();
			// 		console.log(foo);
			// 		// let bar: any = foo;


			// 		resolve();
			// 	})
			// 	.catch((err) => {			// this is a Response object, with res.status === 401, for example
			// 		// TODO - handle errors?
			// 		this.log.error(err);
			// 		reject();
			// 	});


		});
	}
*/




	ensureTemplate(templateFilenameUrl: string, templateParameters: any, mergedFilenameUrl: string) {
		return new Promise( (resolve, reject) => {

			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({
				'Authorization': 'Bearer ' + accessToken,
				'Content-Type': 'application/json'
			});
			let options = new RequestOptions({ headers: headers });
			let payload = {
				templateFilenameUrl: templateFilenameUrl,
				templateParameters: JSON.stringify(templateParameters),
				mergedFilenameUrl: mergedFilenameUrl
			};
			let body = JSON.stringify(payload);

			this.http.post(this.config.basePath + '/v0/templates', body, options)
				.toPromise()
				.then( (res) => {

					// console.log(res);


					let foo = res.json();
					// console.log(foo);
					// let bar: any = foo;


					resolve();
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
					reject(err);
				});
		});
	}



	getEmailList() {
		return new Promise( (resolve, reject) => {

			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			let options = new RequestOptions({ headers: headers });

			this.http.get(this.config.basePath + '/v0/emails', options)
				.toPromise()
				.then((res) => {
					resolve(res.json());
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					this.log.error(err);
					reject(err);
				});
		});
	}



	getEmail(emailAwsId: string) {
		return new Promise( (resolve, reject) => {

			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			let options = new RequestOptions({ headers: headers });

			this.http.get(this.config.basePath + '/v0/emails/' + emailAwsId, options)
				.toPromise()
				.then((res) => {
					resolve(res.json());
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					this.log.error(err);
					reject(err);
				});
		});
	}



	sendTestEmail(displayName: string, email: string, emailProvider: string) {
		return new Promise( (resolve, reject) => {

			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({
				'Authorization': 'Bearer ' + accessToken,
				'Content-Type': 'application/json'
			});
			let options = new RequestOptions({ headers: headers });
			let payload = {
				displayName: displayName,
				email: email,
				emailProvider: emailProvider
			};
			let body = JSON.stringify(payload);

			this.http.post(this.config.basePath + '/v0/emails/test', body, options)
				.toPromise()
				.then((res) => {
					let result = res.json();
					console.log(result);
					resolve(result);
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
					reject(err);
				});
		});
	}

}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/email.service.ts